module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.b3be96cb.woff";